// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrows-module--arrow--3Lmlc","arrowShadow":"Arrows-module--arrowShadow--3-ZuJ"};